(function ($) {
    $.fn.RenderViewVehicle = function (options) {
        var settings = $.extend({
            'label' : 'Action',
            'icon' : '',
            'id' : '',
            'url' : '',
            'data' : [],
        }, options);
        $(this).click(function (e){
            // Specific to invoice printing when no invoice to print.
            if (settings['id'] === 'printInvoice' && !settings['data'][0]['DocEntryFact']) {
                var callFunction = new CallFunction(settings['id'], settings['icon'] + ' fa-2x');
                callFunction.showModal(settings['label']);
                callFunction.addMessage('Aucune de facture à imprimer.', 'text-warning');
                return;
            }

            $('#waiting-modal').modal();
            var $form = $(this).closest('form');
            var formData = $form.serializeArray();
            var url = $form.attr('action');
            $.ajax({
                url : url,
                type: $form.attr('method'),
                data : formData,
                success: function(html) {
                    var $alert = $(html).find('#flash').children('.alert-danger');
                    if ($alert.length > 0){
                        var newDoc = document.open("text/html", "replace");
                        newDoc.write(html);
                        newDoc.close();
                    } else {
                        $('#waiting-modal').modal('hide');
                        var callFunction = new CallFunction(settings['id'], settings['icon'] + ' fa-2x');
                        var data = JSON.stringify(settings['data']);
                        callFunction.showModal(settings['label']);
                        callFunction.startLoading();

                        $.ajax({
                            type: 'POST',
                            data: {data},
                            url: settings['url'],
                            success: function (rep) {
                                callFunction.modalBody.innerHTML = rep.template;
                                if (typeof rep.functionToCall !== 'undefined') {
                                    callFunction.addValidateBtn(function () {
                                        eval(rep.functionToCall + '(data, callFunction)');
                                    });
                                }
                            },
                            error: function (rep, textStatus, errorThrown) {
                                var errMessage =  'Une erreur est survenue.';
                                if (textStatus) {
                                    errMessage += ' (Détail : '+textStatus;
                                    if (errorThrown) {
                                        errMessage += ' / '+errorThrown;
                                    }
                                    errMessage += ')'
                                }
                                callFunction.addLineResult(errMessage, 'danger')
                            },
                            complete: function () {
                                callFunction.stopLoading();
                            }
                        });
                    }
                }
            });
        });
    };
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/render_view_vehicle.js